import { render, staticRenderFns } from "./CommonCkEditor.vue?vue&type=template&id=f168c7d8&scoped=true"
import script from "./CommonCkEditor.vue?vue&type=script&lang=js"
export * from "./CommonCkEditor.vue?vue&type=script&lang=js"
import style0 from "./CommonCkEditor.vue?vue&type=style&index=0&id=f168c7d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f168c7d8",
  null
  
)

export default component.exports